<ng-container *ngIf="jobRequest">
  <div
    *ngIf="compact; else fullView"
    class="compact-job-list-item-row"
    [class.is-canceled]="
      jobRequest.status === JobStatusEnum.CANCELED ||
      jobRequest.jobRequestRejected
    "
    [attr.data-cy]="'job-request-list-item-id-' + jobRequest?._id">
    <div
      class="compact-job-list-item-backdrop"
      [class.without-after]="showJobDate"></div>
    <div class="status-bar-wrapper-container">
      <div class="status-bar-wrapper">
        <div
          class="status-bar"
          [class.green]="
            (jobRequest.status === JobStatusEnum.JOB_REQUESTED &&
              !jobRequest.jobRequestRejected &&
              !loggedInCustomer?.approvedJobRequestsNoLongerActionRequired) ||
            (jobRequest.status === JobStatusEnum.OPEN &&
              !loggedInCustomer?.approvedJobRequestsNoLongerActionRequired)
          "
          [class.gold]="jobRequest.status === JobStatusEnum.CLOSED"
          [class.red]="
            jobRequest.status === JobStatusEnum.CANCELED ||
            jobRequest.jobRequestRejected
          "></div>
      </div>
    </div>
    <div class="compact-job-list-item">
      <div
        *ngFor="let column of columns; trackBy: trackByColumnKey"
        class="compact-job-list-item-column"
        [attr.data-column-key]="column.key"
        [class.with-text-ellipsis]="column.key !== 'status'"
        [class.with-text-m]="column.key === 'organisation'"
        [class.with-fade-right]="column.key === 'status'"
        [class.with-small-spacing]="column.smallSpacing">
        <ng-container [ngSwitch]="column.key">
          <span *ngSwitchCase="'status'">
            <span
              *ngIf="
                jobRequest.status === JobStatusEnum.JOB_REQUESTED &&
                !jobRequest.jobRequestRejected &&
                !jobRequest.jobRequestApproved
              "
              data-cy="job-request-opened-at-message"
              >{{
                "requestOpenedAt"
                  | i18n
                    : {
                        date:
                          (jobRequest.createdAt * 1000 | date: "dd.MM.yyyy") +
                          (" (" +
                            ((jobRequest.createdAt || 0) * 1000
                              | convertToDateObject
                              | formatDistance) +
                            ")")
                      }
              }}</span
            >
            <span
              *ngIf="jobRequest.jobRequestRejected"
              data-cy="job-request-rejected-at-message">
              {{
                "requestRejectedAtBy"
                  | i18n
                    : {
                        date:
                          (jobRequest.jobRequestRejected?.timestamp
                            | date: "dd.MM.yyyy") +
                          (" (" +
                            (jobRequest.jobRequestRejected?.timestamp
                              | formatDistance) +
                            ")"),
                        name:
                          (jobRequest.jobRequestRejected?.firstName || "") +
                          " " +
                          (jobRequest.jobRequestRejected?.lastName || "")
                      }
              }}
            </span>
            <span
              *ngIf="jobRequest.status === JobStatusEnum.OPEN"
              data-cy="job-request-approved-at-message">
              <ng-container
                *ngIf="
                  jobRequest.jobRequestApproved?.firstName &&
                    jobRequest.jobRequestApproved?.lastName;
                  else approvedWithoutName
                ">
                {{
                  "requestApprovedAtBy"
                    | i18n
                      : {
                          date:
                            ((jobRequest.jobRequestApproved?.timestamp
                              | date: "dd.MM.yyyy") ||
                              (jobRequest.updatedAt * 1000
                                | date: "dd.MM.yyyy")) +
                            (" (" +
                              ((jobRequest.jobRequestApproved?.timestamp
                                ? jobRequest.jobRequestApproved?.timestamp
                                : ((jobRequest.updatedAt || 0) * 1000
                                  | convertToDateObject)
                              ) | formatDistance) +
                              ")"),
                          name:
                            (jobRequest.jobRequestApproved?.firstName || "") +
                            " " +
                            (jobRequest.jobRequestApproved?.lastName || "")
                        }
                }}
              </ng-container>
              <ng-template #approvedWithoutName>
                {{
                  "requestApprovedAt"
                    | i18n
                      : {
                          date:
                            (jobRequest.updatedAt * 1000 | date: "dd.MM.yyyy") +
                            (" (" +
                              ((jobRequest.updatedAt || 0) * 1000
                                | convertToDateObject
                                | formatDistance) +
                              ")")
                        }
                }}
              </ng-template>
            </span>
            <span
              *ngIf="
                jobRequest.status === JobStatusEnum.CANCELED &&
                !jobRequest.invitees?.length &&
                !jobRequest.requestRetractedAt
              "
              >{{
                "requestRejectedAt"
                  | i18n
                    : {
                        date:
                          (jobRequest.updatedAt * 1000 | date: "dd.MM.yyyy") +
                          (" (" +
                            ((jobRequest.updatedAt || 0) * 1000
                              | convertToDateObject
                              | formatDistance) +
                            ")")
                      }
              }}</span
            >
            <span *ngIf="jobRequest.status === JobStatusEnum.CLOSED">{{
              "requestBookedAt"
                | i18n
                  : {
                      date:
                        (jobRequest.updatedAt * 1000 | date: "dd.MM.yyyy") +
                        (" (" +
                          ((jobRequest.updatedAt || 0) * 1000
                            | convertToDateObject
                            | formatDistance) +
                          ")")
                    }
            }}</span>
            <span
              *ngIf="
                jobRequest.status === JobStatusEnum.ARCHIVED &&
                !jobRequest.jobRequestRejected
              "
              data-cy="job-request-archived-at-message"
              >{{
                "requestArchivedAt"
                  | i18n
                    : {
                        date:
                          (jobRequest.updatedAt * 1000 | date: "dd.MM.yyyy") +
                          (" (" +
                            ((jobRequest.updatedAt || 0) * 1000
                              | convertToDateObject
                              | formatDistance) +
                            ")")
                      }
              }}</span
            >
            <span
              *ngIf="
                jobRequest.status === JobStatusEnum.CANCELED &&
                !jobRequest.requestRetractedAt &&
                jobRequest.invitees?.length
              "
              >{{
                "requestCanceledAt"
                  | i18n
                    : {
                        date:
                          (jobRequest.updatedAt * 1000 | date: "dd.MM.yyyy") +
                          (" (" +
                            ((jobRequest.updatedAt || 0) * 1000
                              | convertToDateObject
                              | formatDistance) +
                            ")")
                      }
              }}</span
            >
            <span
              *ngIf="
                jobRequest.status === JobStatusEnum.CANCELED &&
                jobRequest.requestRetractedAt
              "
              >{{
                "requestRetractedAt"
                  | i18n
                    : {
                        date:
                          (jobRequest.updatedAt * 1000 | date: "dd.MM.yyyy") +
                          " (" +
                          ((jobRequest.updatedAt || 0) * 1000
                            | convertToDateObject
                            | formatDistance) +
                          ")"
                      }
              }}</span
            >
          </span>
          <span *ngSwitchCase="'shift'">
            <app-job-list-item-date-time
              [withDate]="false"
              [job]="jobRequest"></app-job-list-item-date-time>
          </span>
          <span *ngSwitchCase="'jobType'">
            {{ ("jobTypeEnum." + (jobRequest?.jobType || "") | i18n) || "" }}
          </span>
          <span *ngSwitchCase="'demandReason'">
            <ng-container
              *ngIf="jobRequest?.customerInternalInformation?.[(dispoCustomer$ | async)?._id || '']?.demandReason">
              <ng-container
                *ngIf="!jobRequest?.customerInternalInformation?.[(dispoCustomer$ | async)?._id || '']?.demandReason?.enableDescription; else otherReason">
                {{jobRequest?.customerInternalInformation?.[(dispoCustomer$ |
                async)?._id || '']?.demandReason?.displayName|| ''}}
              </ng-container>
              <ng-template #otherReason>
                {{ (jobRequest?.customerInternalInformation?.[(dispoCustomer$ |
                async)?._id || '']?.demandReason?.displayName || '') + ": "}}
                {{
                jobRequest?.customerInternalInformation?.[(dispoCustomer$ |
                async)?._id || '']?.demandReasonDescription || '' }}
              </ng-template>
            </ng-container>
          </span>
          <span *ngSwitchCase="'bookedEmployee'">
            <ng-container *ngIf="jobRequest.invitees?.length">
              <div
                *ngFor="let invitee of jobRequest.invitees"
                class="users-list-item">
                <app-job-request-invitee
                  data-cy="booked-user-list-item"
                  [invitee]="invitee"
                  [loggedInCustomer]="loggedInCustomer"
                  [uncollapsable]="true"
                  [isCanceled]="
                    invitee.status === InviteeStatusEnum.CANCELED
                  "></app-job-request-invitee>
              </div>
            </ng-container>
          </span>
          <span *ngSwitchCase="'createdAt'">
            {{
              jobRequest.createdAt * 1000
                | convertToDateObject
                | displayDate: "dd.MM.yyyy HH:mm"
            }}
          </span>
          <span *ngSwitchCase="'createdBy'">
            {{ jobRequest.createdBy.firstName }}
            {{ jobRequest.createdBy.lastName }}
          </span>
          <span *ngSwitchCase="'date'">
            {{ jobRequest.date | date: "dd.MM.yyyy" }}
          </span>
          <span *ngSwitchCase="'department'">
            <app-job-list-item-organisation-heading
              [department]="jobRequest.department"
              [organisation]="jobRequest.organisation"
              [departmentOnly]="true"
              [compact]="true"></app-job-list-item-organisation-heading>
          </span>
          <span *ngSwitchCase="'organisation'">
            {{ jobRequest.organisation?.name }}
          </span>
        </ng-container>
      </div>
    </div>
    <div
      class="compact-job-list-item-footer"
      [class.empty-footer]="
        !(
          ((jobRequest.status === JobStatusEnum.JOB_REQUESTED ||
            jobRequest.status === JobStatusEnum.OPEN) &&
            jobRequest.requestedAt &&
            !readOnly) ||
          ((canApproveJobRequests$ | async) &&
            jobRequest.status === JobStatusEnum.JOB_REQUESTED)
        )
      ">
      <ng-container
        *ngIf="
          (canApproveJobRequests$ | async) &&
            (jobRequest.status === JobStatusEnum.JOB_REQUESTED ||
              (jobRequest.requestRetractionRequestedAt &&
                jobRequest.status === JobStatusEnum.CLOSED));
          else compactRequesterActions
        ">
        <ng-container
          *ngIf="
            jobRequest.status === JobStatusEnum.JOB_REQUESTED;
            else compactRetractionRequestedActions
          ">
          <button
            *ngIf="!jobRequest.jobRequestRejected"
            class="outline-pill-button text-error icon-only"
            type="button"
            (click)="rejectRequest()"
            data-cy="reject-request-button"
            [matTooltip]="('reject' | i18n) || 'Ablehnen' | titlecase">
            <mat-icon svgIcon="close"></mat-icon>
          </button>
          <button
            class="outline-pill-button text-secondary icon-only"
            type="button"
            (click)="approveRequest()"
            data-cy="approve-request-button"
            [matTooltip]="('approve' | i18n) || 'Freigeben' | titlecase">
            <mat-icon svgIcon="check"></mat-icon>
          </button>
        </ng-container>
        <ng-template #compactRetractionRequestedActions>
          <button
            class="outline-pill-button text-error icon-only"
            type="button"
            (click)="approveRetractionOnRequest()"
            data-cy="approve-retraction-on-request-button"
            [matTooltip]="
              ('approveRetractionOnRequest' | i18n) || 'Zurückziehen freigeben'
                | titlecase
            ">
            <mat-icon svgIcon="close"></mat-icon>
          </button>

          <button
            class="outline-pill-button icon-only"
            type="button"
            (click)="rejectRetractionOnRequest()"
            data-cy="reject-retraction-on-request-button"
            [matTooltip]="
              ('rejectRetractionOnRequest' | i18n) || 'Zurückziehen ablehnen'
                | titlecase
            ">
            <mat-icon svgIcon="do_not_disturb_on"></mat-icon>
          </button>
        </ng-template>
      </ng-container>
      <ng-template #compactRequesterActions>
        <button
          *ngIf="
            (jobRequest.status === JobStatusEnum.JOB_REQUESTED ||
              jobRequest.status === JobStatusEnum.OPEN) &&
            !readOnly
          "
          class="outline-pill-button icon-only"
          type="button"
          (click)="retractRequest()"
          data-cy="retract-request-button"
          [matTooltip]="('retract' | i18n) || 'Zurückziehen' | titlecase">
          <mat-icon svgIcon="do_not_disturb_on"></mat-icon>
        </button>
        <button
          *ngIf="
            jobRequest.status === JobStatusEnum.CLOSED &&
            !readOnly &&
            !jobRequest.requestRetractionRequestedAt
          "
          class="outline-pill-button icon-only"
          type="button"
          (click)="requestRetractionOnRequest()"
          data-cy="request-retraction-on-request-button"
          [matTooltip]="
            ('requestRetraction' | i18n) || 'Zurückziehen anfragen' | titlecase
          ">
          <mat-icon svgIcon="do_not_disturb_on"></mat-icon>
        </button>
      </ng-template>
    </div>
  </div>
  <ng-template #fullView>
    <div
      class="job-request-list-item"
      [attr.data-cy]="'job-request-list-item-id-' + jobRequest?._id"
      [class.green]="
        (jobRequest.status === JobStatusEnum.JOB_REQUESTED &&
          !jobRequest.jobRequestRejected &&
          !loggedInCustomer?.approvedJobRequestsNoLongerActionRequired) ||
        (jobRequest.status === JobStatusEnum.OPEN &&
          !loggedInCustomer?.approvedJobRequestsNoLongerActionRequired)
      "
      [class.gold]="jobRequest.status === JobStatusEnum.CLOSED"
      [class.red]="
        jobRequest.status === JobStatusEnum.CANCELED ||
        jobRequest.jobRequestRejected
      ">
      <div class="status-bar"></div>
      <div class="header-meta">
        <app-job-list-item-date-time
          *ngIf="showJobDate; else shiftsWithoutDate"
          [withDate]="true"
          [job]="jobRequest"></app-job-list-item-date-time>

        <ng-template #shiftsWithoutDate>
          <div
            *ngFor="let shift of jobRequest.shifts"
            class="job-shift"
            data-cy="shift-time">
            <div class="job-shift-tag">
              {{
                shift.label
                  ? shift.label
                  : ("shifts." + shift.shift | i18n | titlecase)
              }}
            </div>
            <div class="job-shift-time">
              {{ shift.from | time }} - {{ shift.to | time }}
            </div>
          </div>
        </ng-template>
      </div>
      <app-job-list-item-organisation-heading
        *ngIf="showDepartment"
        class="job-heading"
        jobType="job-request"
        [department]="jobRequest.department"
        [organisation]="
          jobRequest.organisation
        "></app-job-list-item-organisation-heading>
      <div>
        <table class="details-table">
          <tr
            *ngIf="
              loggedInCustomer?.enableCaseNumberInJobRequests &&
              jobRequest.caseNumber
            ">
            <td class="detail-label">
              {{ ("caseNumber" | i18n) || "Fallnummer" }}
            </td>
            <td>{{ jobRequest.caseNumber }}</td>
          </tr>
          <tr *ngIf="jobRequest.description">
            <td class="detail-label">
              {{ ("description" | i18n) || "Beschreibung" }}
            </td>
            <td>{{ jobRequest.description }}</td>
          </tr>
          <tr>
            <td class="detail-label">
              {{ ("jobType" | i18n) || "Dienstart" }}
            </td>
            <td>
              {{ ("jobTypeEnum." + (jobRequest?.jobType || "") | i18n) || "" }}
            </td>
          </tr>
          <tr
            *ngIf="jobRequest?.customerInternalInformation?.[(dispoCustomer$ | async)?._id || '']?.demandReason">
            <td class="detail-label">{{ ("reason" | i18n) || "Grund" }}</td>
            <td>
              <ng-container
                *ngIf="!jobRequest?.customerInternalInformation?.[(dispoCustomer$ | async)?._id || '']?.demandReason?.enableDescription; else otherReason">
                {{jobRequest?.customerInternalInformation?.[(dispoCustomer$ |
              async)?._id || '']?.demandReason?.displayName|| ''}}
              </ng-container>
              <ng-template #otherReason>
                {{ (jobRequest?.customerInternalInformation?.[(dispoCustomer$ |
              async)?._id || '']?.demandReason?.displayName || '') + ": "}}
                {{
              jobRequest?.customerInternalInformation?.[(dispoCustomer$ |
              async)?._id || '']?.demandReasonDescription || '' }}
              </ng-template>
            </td>
          </tr>
          <tr>
            <td class="detail-label">
              {{ ("created" | i18n) || "Erstellt" }}
            </td>
            <td *ngIf="jobRequest.createdAt">
              {{
                jobRequest.createdAt * 1000
                  | convertToDateObject
                  | displayDate: "dd.MM.yyyy HH:mm"
              }}
              / {{ jobRequest.createdBy.firstName }}
              {{ jobRequest.createdBy.lastName }}
            </td>
          </tr>
          <tr *ngIf="jobRequest.certificates?.length">
            <td class="detail-label">
              {{ ("qualifications" | i18n) || "Qualifikation" | titlecase }}
            </td>
            <td>
              <span
                *ngFor="
                  let certificate of jobRequest.certificates;
                  let i = index
                "
                >{{ (i > 0 ? ", " : "") + certificate.displayName }}</span
              >
            </td>
          </tr>
          <tr *ngIf="jobRequest.sex !== undefined">
            <td class="detail-label">{{ ("sex" | i18n) || "Geschlecht" }}</td>
            <td>
              {{
                jobRequest.sex === sexEnum.MALE
                  ? ("maleSex" | i18n)
                  : ("femaleSex" | i18n)
              }}
            </td>
          </tr>
          <tr *ngIf="jobRequest.poolerTypes?.length">
            <td class="detail-label">
              {{ ("poolerTypes" | i18n) || "Poolertypen" | titlecase }}
            </td>
            <td>
              <span
                *ngFor="let poolerType of jobRequest.poolerTypes; let i = index"
                >{{ (i > 0 ? ", " : "") + poolerType.displayName }}</span
              >
            </td>
          </tr>

          <tr
            *ngIf="jobRequest?.customerInternalInformation?.[loggedInCustomer?._id || '']?.description">
            <td class="detail-label">
              {{ ("internalDescription" | i18n) || "Interne Beschreibung" }}
            </td>
            <td>
              {{ jobRequest?.customerInternalInformation?.[loggedInCustomer?._id || '']?.description || '' }}
            </td>
          </tr>
          <tr
            *ngFor="
              let row of (nonDefaultCustomCriteriaRows$ | async) || [];
              trackBy: trackByCustomCriteriaLabel
            ">
            <td class="detail-label">{{ row.label }}</td>
            <td>
              <ng-container *ngIf="row.toggleValue !== undefined">
                {{ (row.toggleValue ? "yes" : "no") | i18n }}
              </ng-container>
              <ng-container *ngIf="row.toggleValue === undefined">
                {{ row.selectText }}
              </ng-container>
            </td>
          </tr>
        </table>
      </div>
      <div
        *ngIf="jobRequest.invitees.length > 0"
        class="invitees-preview-wrapper">
        <div>
          <div class="users-list">
            <div
              *ngFor="let invitee of jobRequest.invitees"
              class="users-list-item">
              <app-job-request-invitee
                data-cy="booked-user-list-item"
                [invitee]="invitee"
                [loggedInCustomer]="loggedInCustomer"
                [isCanceled]="
                  invitee.status === InviteeStatusEnum.CANCELED
                "></app-job-request-invitee>
            </div>
          </div>
        </div>
      </div>
      <div class="job-request-footer">
        <div class="start-items"></div>
        <div class="end-items">
          <div
            class="job-request-status"
            data-cy="job-request-status">
            <div
              class="job-request-status-text"
              data-cy="job-request-status-text">
              <span
                *ngIf="
                  jobRequest.status === JobStatusEnum.JOB_REQUESTED &&
                  !jobRequest.jobRequestRejected &&
                  !jobRequest.jobRequestApproved
                "
                data-cy="job-request-opened-at-message"
                >{{
                  "requestOpenedAt"
                    | i18n
                      : {
                          date:
                            (jobRequest.createdAt * 1000 | date: "dd.MM.yyyy") +
                            (" (" +
                              ((jobRequest.createdAt || 0) * 1000
                                | convertToDateObject
                                | formatDistance) +
                              ")")
                        }
                }}</span
              >
              <span
                *ngIf="jobRequest.jobRequestRejected"
                data-cy="job-request-rejected-at-message">
                {{
                  "requestRejectedAtBy"
                    | i18n
                      : {
                          date:
                            (jobRequest.jobRequestRejected?.timestamp
                              | date: "dd.MM.yyyy") +
                            (" (" +
                              (jobRequest.jobRequestRejected?.timestamp
                                | formatDistance) +
                              ")"),
                          name:
                            (jobRequest.jobRequestRejected?.firstName || "") +
                            " " +
                            (jobRequest.jobRequestRejected?.lastName || "")
                        }
                }}
              </span>
              <span
                *ngIf="
                  jobRequest.requestRetractionRequestedAt &&
                  jobRequest.status === JobStatusEnum.CLOSED
                ">
                {{
                  "requestRetractionRequestedAt"
                    | i18n
                      : {
                          firstName:
                            jobRequest.requestRetractionRequestedBy
                              ?.firstName || "",
                          lastName:
                            jobRequest.requestRetractionRequestedBy?.lastName ||
                            "",
                          date:
                            (jobRequest.requestRetractionRequestedAt * 1000
                              | date: "dd.MM.yyyy") +
                            (" (" +
                              (jobRequest.requestRetractionRequestedAt * 1000
                                | convertToDateObject
                                | formatDistance) +
                              ")")
                        }
                }}
              </span>
              <span
                *ngIf="
                  jobRequest.status === JobStatusEnum.OPEN &&
                  !jobRequest.requestRetractionRequestedAt
                "
                data-cy="job-request-approved-at-message">
                <ng-container
                  *ngIf="
                    jobRequest.jobRequestApproved?.firstName &&
                      jobRequest.jobRequestApproved?.lastName;
                    else approvedWithoutName
                  ">
                  {{
                    "requestApprovedAtBy"
                      | i18n
                        : {
                            date:
                              ((jobRequest.jobRequestApproved?.timestamp
                                | date: "dd.MM.yyyy") ||
                                (jobRequest.updatedAt * 1000
                                  | date: "dd.MM.yyyy")) +
                              (" (" +
                                ((jobRequest.jobRequestApproved?.timestamp
                                  ? jobRequest.jobRequestApproved?.timestamp
                                  : ((jobRequest.updatedAt || 0) * 1000
                                    | convertToDateObject)
                                ) | formatDistance) +
                                ")"),
                            name:
                              (jobRequest.jobRequestApproved?.firstName || "") +
                              " " +
                              (jobRequest.jobRequestApproved?.lastName || "")
                          }
                  }}
                </ng-container>
                <ng-template #approvedWithoutName>
                  {{
                    "requestApprovedAt"
                      | i18n
                        : {
                            date:
                              (jobRequest.updatedAt * 1000
                                | date: "dd.MM.yyyy") +
                              (" (" +
                                ((jobRequest.updatedAt || 0) * 1000
                                  | convertToDateObject
                                  | formatDistance) +
                                ")")
                          }
                  }}
                </ng-template>
              </span>
              <span
                *ngIf="
                  jobRequest.status === JobStatusEnum.CANCELED &&
                  !jobRequest.invitees?.length &&
                  !jobRequest.requestRetractedAt
                "
                >{{
                  "requestRejectedAt"
                    | i18n
                      : {
                          date:
                            (jobRequest.updatedAt * 1000 | date: "dd.MM.yyyy") +
                            (" (" +
                              ((jobRequest.updatedAt || 0) * 1000
                                | convertToDateObject
                                | formatDistance) +
                              ")")
                        }
                }}</span
              >
              <span
                *ngIf="
                  jobRequest.status === JobStatusEnum.CLOSED &&
                  !jobRequest.requestRetractionRequestedAt
                "
                >{{
                  "requestBookedAt"
                    | i18n
                      : {
                          date:
                            (jobRequest.updatedAt * 1000 | date: "dd.MM.yyyy") +
                            (" (" +
                              ((jobRequest.updatedAt || 0) * 1000
                                | convertToDateObject
                                | formatDistance) +
                              ")")
                        }
                }}</span
              >
              <span
                *ngIf="
                  jobRequest.status === JobStatusEnum.ARCHIVED &&
                  !jobRequest.jobRequestRejected
                "
                data-cy="job-request-archived-at-message"
                >{{
                  "requestArchivedAt"
                    | i18n
                      : {
                          date:
                            (jobRequest.updatedAt * 1000 | date: "dd.MM.yyyy") +
                            (" (" +
                              ((jobRequest.updatedAt || 0) * 1000
                                | convertToDateObject
                                | formatDistance) +
                              ")")
                        }
                }}</span
              >
              <span
                *ngIf="
                  jobRequest.status === JobStatusEnum.CANCELED &&
                  !jobRequest.requestRetractedAt &&
                  jobRequest.invitees?.length
                "
                >{{
                  "requestCanceledAt"
                    | i18n
                      : {
                          date:
                            (jobRequest.updatedAt * 1000 | date: "dd.MM.yyyy") +
                            (" (" +
                              ((jobRequest.updatedAt || 0) * 1000
                                | convertToDateObject
                                | formatDistance) +
                              ")")
                        }
                }}</span
              >
              <span
                *ngIf="
                  jobRequest.status === JobStatusEnum.CANCELED &&
                  jobRequest.requestRetractedAt
                "
                >{{
                  "requestRetractedAt"
                    | i18n
                      : {
                          date:
                            (jobRequest.updatedAt * 1000 | date: "dd.MM.yyyy") +
                            " (" +
                            ((jobRequest.updatedAt || 0) * 1000
                              | convertToDateObject
                              | formatDistance) +
                            ")"
                        }
                }}</span
              >
            </div>
            <div
              class="job-request-status-reason"
              *ngIf="
                jobRequest.status === JobStatusEnum.CANCELED &&
                jobRequest.cancelReason &&
                !jobRequest.requestRetractedAt
              ">
              <span *ngIf="jobRequest.invitees?.length">
                {{ ("cancelReason" | i18n) || "Stornierungsgrund" }}:

                {{
                jobRequest.cancelReason.id !== inviteesCancelledCancelReason.id
                  ? jobRequest.cancelReason.displayName[lang]
                  : jobRequest.invitees[0]?.cancelReason?.displayName?.[lang]
                }}
              </span>
              <span *ngIf="!jobRequest.invitees?.length">
                {{ ("declineReason" | i18n) || "Ablehnungsgrund" }}:
                {{ jobRequest.cancelReason.displayName[lang] }}
              </span>
              <div *ngIf="jobRequest.cancelReasonDescription">
                {{ jobRequest.cancelReasonDescription }}
              </div>
            </div>
          </div>
          <ng-container
            *ngIf="
              (canApproveJobRequests$ | async) &&
                (jobRequest.status === JobStatusEnum.JOB_REQUESTED ||
                  (jobRequest.requestRetractionRequestedAt &&
                    jobRequest.status === JobStatusEnum.CLOSED));
              else requesterActions
            ">
            <div class="approve-action-buttons">
              <ng-container
                *ngIf="
                  jobRequest.status === JobStatusEnum.JOB_REQUESTED;
                  else retractionRequestedActions
                ">
                <button
                  *ngIf="!jobRequest.jobRequestRejected"
                  class="outline-pill-button text-error"
                  type="button"
                  (click)="rejectRequest()"
                  data-cy="reject-request-button">
                  <mat-icon svgIcon="close"></mat-icon>
                  {{ ("reject" | i18n) || "Ablehnen" | titlecase }}
                </button>
                <button
                  class="outline-pill-button text-secondary"
                  type="button"
                  (click)="approveRequest()"
                  data-cy="approve-request-button">
                  <mat-icon svgIcon="check"></mat-icon>
                  {{ ("approve" | i18n) || "Freigeben" | titlecase }}
                </button>
              </ng-container>
              <ng-template #retractionRequestedActions>
                <button
                  class="outline-pill-button"
                  type="button"
                  (click)="rejectRetractionOnRequest()"
                  data-cy="reject-retraction-on-request-button">
                  <mat-icon svgIcon="do_not_disturb_on"></mat-icon>
                  {{ ("decline" | i18n) || "Ablehnen" | titlecase }}
                </button>
                <button
                  class="outline-pill-button text-error"
                  type="button"
                  (click)="approveRetractionOnRequest()"
                  data-cy="approve-retraction-on-request-button">
                  <mat-icon svgIcon="close"></mat-icon>
                  {{ ("accept" | i18n) || "Akzeptieren" | titlecase }}
                </button>
              </ng-template>
            </div>
          </ng-container>
          <ng-template #requesterActions>
            <button
              *ngIf="
                (jobRequest.status === JobStatusEnum.JOB_REQUESTED ||
                  jobRequest.status === JobStatusEnum.OPEN) &&
                !readOnly
              "
              class="outline-pill-button"
              type="button"
              (click)="retractRequest()"
              data-cy="retract-request-button">
              <mat-icon svgIcon="do_not_disturb_on"></mat-icon>
              {{ ("retract" | i18n) || "Zurückziehen" | titlecase }}
            </button>
            <button
              *ngIf="
                jobRequest.status === JobStatusEnum.CLOSED &&
                !readOnly &&
                !jobRequest.requestRetractionRequestedAt
              "
              class="outline-pill-button"
              type="button"
              (click)="requestRetractionOnRequest()"
              data-cy="request-retraction-on-request-button">
              <mat-icon svgIcon="do_not_disturb_on"></mat-icon>
              {{
                ("requestRetraction" | i18n) || "Zurückziehen anfragen"
                  | titlecase
              }}
            </button>
          </ng-template>
        </div>
      </div>
    </div>
  </ng-template>
</ng-container>
